var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52876 3.52864C9.26841 3.78899 9.26841 4.2111 9.52876 4.47145L12.3907 7.33337H6.00016C5.63197 7.33337 5.3335 7.63185 5.3335 8.00004C5.3335 8.36823 5.63197 8.66671 6.00016 8.66671H12.3907L9.52876 11.5286C9.26841 11.789 9.26841 12.2111 9.52876 12.4714C9.78911 12.7318 10.2112 12.7318 10.4716 12.4714L14.4716 8.47145C14.7319 8.2111 14.7319 7.78899 14.4716 7.52864L10.4716 3.52864C10.2112 3.26829 9.78911 3.26829 9.52876 3.52864ZM3.3335 8.66671H2.00016C1.63197 8.66671 1.3335 8.36823 1.3335 8.00004C1.3335 7.63185 1.63197 7.33337 2.00016 7.33337H3.3335C3.70169 7.33337 4.00016 7.63185 4.00016 8.00004C4.00016 8.36823 3.70169 8.66671 3.3335 8.66671Z",
    fill: "#0397C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.2c853399e74e107fb9f54a218b86c92e.svg";
export { ForwardRef as ReactComponent };